import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCakeCandles,
  faGift,
  faLock,
  faLocationDot,
  faUserGroup,
  faUserShield
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import backgroundImage from '../Images/fundoaniversario.png';
import '../CSS/Despedidas.css';

const BirthdayParties = () => {
  return (
    <div className="er-partyPage">
      <section className="er-partyHero" aria-label="Birthday parties">
        <img src={backgroundImage} alt="" className="er-partyHeroImg" />
        <div className="er-partyHeroOverlay">
          <div className="er-partyHeroInner">
            <div className="er-partyBadge">Adventure • Laughs • Surprises</div>

            <h1 className="er-partyTitle">
              Unforgettable <span className="er-partyTitleAccent">Birthdays</span>
            </h1>

            <p className="er-partyLead">Celebrate in a different way!</p>
            <p className="er-partyText">
              Bring friends and family together for a challenge full of adrenaline, mystery and moments to tell.
              Perfect for marking the day in a unique way — with plans tailored to your group.
            </p>

            <div className="er-partyCtas">
              <a
                className="er-partyCtaPrimary"
                href="https://wa.me/351934403133"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
                Talk to us
              </a>
            </div>
          </div>

          <div className="er-partyHeroCards">
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faCakeCandles} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Party with adrenaline</h2>
              <p className="er-partyHeroCardText">
                A different celebration: high energy and fun from the very first minute.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faLock} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Epic challenges</h2>
              <p className="er-partyHeroCardText">
                Puzzles to test your group’s teamwork and creativity.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faGift} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Unique memories</h2>
              <p className="er-partyHeroCardText">
                Moments to remember and stories to share long after.
              </p>
            </article>
          </div>

          <div className="er-partyHeroCards">
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserGroup} className="er-partyFeatureIcon" />
              <h3 className="er-partyHeroCardTitle">For every group</h3>
              <p className="er-partyFeatureText">
                We adapt to your group size and pace.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faLocationDot} className="er-partyFeatureIcon" />
              <h2 className="er-partyHeroCardTitle">Great location</h2>
              <p className="er-partyFeatureText">
                In the heart of Bragança — easy to reach and perfect to keep the party going.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserShield} className="er-partyFeatureIcon" />
              <h3 className="er-partyHeroCardTitle">Dedicated team</h3>
              <p className="er-partyFeatureText">
                Support before, during and after the game so everything runs smoothly.
              </p>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BirthdayParties;
